export const getCategoriesOptions = (categories) =>
  (categories || []).map(({ Title, Id }) => ({ value: Id, name: Title }));

export const getPartnerTagOptions = (tags) =>
  (tags || []).map(({ Name, Id }) => ({ value: Id, name: Name }));
